<template>
  <!-- :size="option.attribute.size"   :shape="option.attribute.badgeShape"-->
  <t-badge class="my-badge" :color="option.attribute.bgColor" :style="setStyles" :count="iptVal"
    :showZero="option.attribute.showZero" :maxCount="999999" />
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,

  hasProperty,
} from "@/utils/refresh-cpt-data";
export default {
  name: "cpt-badge",
  props: {
    option: Object,
    refMap: Object, current: Object,
    components: Array,
    scale: Number,
  },
  computed: {
    setStyles() {
      console.log(this.option, this.current, 'qwidjqwiqijd0qwijd0qwid0jqi0jqi0j');
      let style = {
        "--width": this.option.attribute.width + "px",
        "--height": this.option.attribute.height + "px",
        "--lineHeight": this.option.attribute.height + "px",
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--textColor": this.option.attribute.textColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
      };
      const isDesign = location.href.includes('/design')
      if (!isDesign) {
        console.log('?????');
        const { isTabGroupId } = this.option.attribute
        if (isTabGroupId) {
          const tab = this.components?.find(x => x.id == isTabGroupId)
          // console.log(tab, this.current, tab.cptY, this.current.cptY, 'adopkasoidasdopkkopaskopsadokp');
          if (tab) {
            const { isFiexd, position, postitionY, postitionX } = tab.cptOption.attribute
            if (isFiexd) {
              style['position'] = 'fixed'
              style['z-index'] = this.current.cptOption.attribute.cptIndex

              style[position] = ((postitionY + (tab.cptY - this.current.cptY)) + tab.cptHeight - (this.current.cptHeight / 1.3))  + 'px'

              if (postitionX) {
                let x = this.current.cptX - tab.cptX
                style['left'] = (postitionX + x) + 'px'
              } else {
                style['left'] = ((this.current.cptX - tab.cptX) * this.scale.containerScaleX) + tab.cptX + 'px';
              }


            }
          }

        }

      }


      return style
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  data() {
    return {
      iptVal: "",
      newData: "",
      jsFunFlag: false,
      uuid: null,
    };
  },
  watch: {
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }

    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      console.log('asdkiojnaosikojasdjioadjiokasdjioadaiojdad');

      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
        if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') return

        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
          //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.iptVal = newres[0].value;
          }
        } else {
          // 如果配置了转换脚本
          this.iptVal = res.value;
        }
      } else {
        // 不是数据集类型，是静态数据
        this.iptVal = res.value;
      }
    },
  },
};
</script>

<style>
.my-badge {
  margin-left: 15px !important;
}

.my-badge .t-badge--circle {
  min-width: var(--width);
  height: var(--height);
  line-height: var(--lineHeight);
  border-radius: var(--borderRadius);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
}

.my-badge .t-badge--round {
  min-width: var(--width);
  height: var(--height);
  line-height: var(--lineHeight);
  border-radius: var(--borderRadius);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
}
</style>